import React from 'react'
import Sidebar from './components/sidebar/Sidebar'
// import Topbar from './components/topbar/Topbar'
import './App.css'
//import Home from './pages/home/Home'
import Dashboard from './pages/dashboard/Dashboard'
import UserInfo from './pages/userInfo/UserInfo.js'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

import UploadData from './pages/uploadData/UploadData'
import MarketingResources from './pages/marketingResources/MarketingResources'
import UploadResources from './pages/uploadResources/UploadResources'

import Login from './pages/login/Login'
import ForgotPassword from './pages/forgotPassword/ForgotPassword'
import Signup from './pages/signup/Signup'
import NewAffiliate from './pages/newAffiliate/NewAffiliate'
import { useContext } from 'react'
import { AuthContext } from './context/authContext/AuthContext'

function App() {
  const { user } = useContext(AuthContext)
  return (
    <Router>
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/login`}>
          {user && user.result.isAdmin === true ? (
            <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />
          ) : user && user.result.isUser === true ? (
            <Redirect to={`${process.env.PUBLIC_URL}/user`} />
          ) : (
            <Login />
          )}
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/signup`}>
          <Signup />
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/forgot-password`}>
          <ForgotPassword />
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/new-affiliate`}>
          <NewAffiliate />
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/user`}>
          {!user ? (
            <Redirect to={`${process.env.PUBLIC_URL}/login`} />
          ) : (
            <UserInfo />
          )}
        </Route>
        {user && user.result.isAdmin === true ? (
          <>
            <Sidebar />
            <div className='container'>
              <Route exact path={`${process.env.PUBLIC_URL}/`}>
                <Dashboard />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard`}>
                {user && user.result.isUser === true ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/user`} />
                ) : (
                  <Dashboard />
                )}
              </Route>

              <Route path={`${process.env.PUBLIC_URL}/upload-data`}>
                {user && user.result.isUser === true ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/user`} />
                ) : (
                  <UploadData />
                )}
              </Route>

              <Route path={`${process.env.PUBLIC_URL}/marketing-resources`}>
                {user && user.result.isUser === true ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/user`} />
                ) : (
                  <MarketingResources />
                )}
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/upload-resources`}>
                {user && user.result.isUser === true ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/user`} />
                ) : (
                  <UploadResources />
                )}
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/user`}>
                <UserInfo />
              </Route>
            </div>
          </>
        ) : user && user.result.isAdmin === false ? (
          <>
            <div className='container'>
              <Route path={`${process.env.PUBLIC_URL}/`}>
                <UserInfo />
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/user`}>
                <UserInfo />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard`}>
                <Redirect to={`${process.env.PUBLIC_URL}/user`} />
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/upload-resources`}>
                <Redirect to={`${process.env.PUBLIC_URL}/user`} />
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/marketing-resources`}>
                <Redirect to={`${process.env.PUBLIC_URL}/user`} />
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/upload-data`}>
                <Redirect to={`${process.env.PUBLIC_URL}/user`} />
              </Route>
            </div>
          </>
        ) : (
          <Redirect to={`${process.env.PUBLIC_URL}/login`} />
        )}
      </Switch>
    </Router>
  )
}

export default App
